import APIService from '@/services/APIService.js';

export default {
  getAllTratativas() {
    return APIService.apiCall().get('/tratativasArquivos/getAllTrativas');
  },
  getAllExecucoes() {
    return APIService.apiCall().get('/tratativasArquivos/getAllExecucoes');
  },
  processarTratativa(id, postData) {
    return APIService.apiCall().post(`/tratativasArquivos/processar/${id}`, JSON.stringify(postData));
  }
};
